import Profile from './Main/Profile/Profile';
import Sections from './Main/Sections/Sections';
import Projects from "./Main/Projects/Projects"

function App() {
  return (
    <>
      <Profile />
      <Sections />
      <Projects />
    </>
  );
}

export default App;